import { Type } from "class-transformer";
import { ClientKind } from "../../client/client-kind";
import { ClientOtherBuyerRole } from "../../client/client-other-buyer-role";
import { TinKind } from "../../client/tax-identification-numer-kind";

export class AddressDTO {
	public address: string;
	public city: string;
	public countryId: number;
	public line2: string | null;
	public name: string;
	public zipCode: string;
}

export class DocumentClientDTO {
	@Type(() => AddressDTO) public address: AddressDTO | null;
	public clientId: number | null;
	public kind: ClientKind;
	public name: string;
	public tin: string;
	public tinKind: TinKind;
	public emails: string[];
    public internalIdentificationNumber: string | null;
}

export class DocumentBuyerDTO extends DocumentClientDTO {
	public role: ClientOtherBuyerRole | null;
}

export class InventoryDocumentClientDTO {
	@Type(() => AddressDTO) public address: AddressDTO | null;
	public contractorId: number | null;
	public kind: ClientKind;
	public name: string;
	public tin: string;
	public tinKind: TinKind;
	public emails: string[];
    public internalIdentificationNumber: string | null;
}

export class InventoryDocumentBuyerDTO extends InventoryDocumentClientDTO {
	public role: ClientOtherBuyerRole | null;
}
